import { Injectable } from '@angular/core';

import { SharedObject } from 'src/app/models';
import { ModalService } from 'src/app/services';
import {
  IProductionAreaOverrideModal,
  ProductionAreaOverrideModal
} from './production-area-override.modal';

@Injectable()
export class ProductionAreaOverrideModalService {
  constructor(private readonly modalService: ModalService) {}

  showModal(payload: IProductionAreaOverrideModal) {
    this.modalService.showModal<
      { selected: SharedObject },
      IProductionAreaOverrideModal
    >(ProductionAreaOverrideModal, payload, {
      cssClass: ['dynamic-height-modal', 'small-modal', 'border-radius-px-8'],
      backdropDismiss: false
    });
  }
}
